import axios from 'axios';
import { domain } from '../../utils/helpers.jsx';

const cfg = { withCredentials: true };

export const login = (email, password) =>
    axios.post(`${domain}/api/auth/login`, { email, password }, cfg);

export const register = (email, password) =>
    axios.post(`${domain}/api/auth/register`, { email, password }, cfg);

export const logOut = () =>
    axios.post(`${domain}/api/auth/logout`, {}, cfg);

export const requestPasswordReset = (email) =>
    axios.post(`${domain}/api/auth/password-reset`, { email }, cfg);

export const confirmPasswordReset = (token, uid, newPassword) =>
    axios.post(`${domain}/api/auth/password-reset/confirm`, { token, uid, newPassword }, cfg);

export const fetchCurrentUser = () =>
    axios.get(`${domain}/api/auth/me`, cfg);

export const loginWithGoogle = (access_token) =>
    axios.post(`${domain}/api/auth/login/google`, { access_token }, cfg);

export const resendVerification = () =>
    axios.post(`${domain}/api/auth/resend-verification`, {}, cfg);

export const verifyEmailToken = (token, uid) =>
    axios.get(`${domain}/api/auth/verify-email`, { params: { token, uid }, ...cfg });
